var map = {
	"./backgrounds/contact/contact-us-2993000_1920.jpg": "dfab",
	"./backgrounds/contact/contact_back.jpg": "171c",
	"./backgrounds/contact/image-from-rawpixel-id-1078672-original.jpg": "1a26",
	"./backgrounds/home/background reserve now.jpg": "410b",
	"./backgrounds/home/image-from-rawpixel-id-2312450-jpeg.jpg": "1c2c",
	"./backgrounds/login/loginBg.jpg": "eff0",
	"./backgrounds/order/order-1.png": "3ba6",
	"./backgrounds/order/order-2.png": "64e8",
	"./backgrounds/order/order-3.jpg": "0a3a",
	"./backgrounds/order/order-4.jpg": "2f2e",
	"./backgrounds/reserve/background reserve now.jpg": "d310",
	"./delever2.png": "f958",
	"./fatima-akram-uU0Anw-8Vsg-unsplash.jpg": "f0cd",
	"./food/burgures/5882486ce81acb96424ffaae.png": "a29b",
	"./food/burgures/Big Burger .png": "e344",
	"./food/burgures/Burger Fries.png": "59f8",
	"./food/burgures/Chicken Burger.png": "9efe",
	"./food/burgures/Fish Burger.png": "88f3",
	"./food/burgures/KFC Double .png": "e0d8",
	"./food/chickens/Kfc Chicken Nuggets.png": "b098",
	"./food/chickens/Kfc Signature Box.png": "1568",
	"./food/chickens/Kfc Twister Box.png": "a1c2",
	"./food/chickens/alyssa-li-n2z5UL4E4Og-unsplash.jpg": "bd87",
	"./food/chickens/plate-of-rice-and-cooked-meat-1624487.jpg": "1100",
	"./food/chickens/tsering-pemba-_ccJa73HR2I-unsplash.jpg": "3868",
	"./food/desserts/Ice Cream Berries.png": "0577",
	"./food/desserts/Strawberry Horn Ice Cream.png": "68ed",
	"./food/desserts/Strawberry Parfait Ice Cream.png": "9418",
	"./food/drinks/Can Pepsi .png": "acdc",
	"./food/drinks/Coca Cola Papercup.png": "6e5b",
	"./food/drinks/Coke Light Bottle Coca Cola.png": "d6a2",
	"./food/drinks/Fanta Orange Bottle .png": "6502",
	"./food/drinks/Fanta Orange Can.png": "c54e",
	"./food/drinks/Glass Bottle Pepsi .png": "e81c",
	"./food/drinks/Plastic Bottle Pepsi .png": "40d7",
	"./food/drinks/Regular Coke Can Coca Cola.png": "a964",
	"./food/pizza/close-up-photo-of-pizza-2619970.jpg": "7773",
	"./food/pizza/jonas-kakaroto-BHdZZQWrcwM-unsplash.jpg": "70c3",
	"./food/pizza/muhammad-umair-TxQSdnp6D_k-unsplash.jpg": "5f06",
	"./food/pizza/pizza.png": "8117",
	"./food/pizza/pizza_one.png": "6374",
	"./food/pizza/pizza_three.png": "da4d",
	"./food/pizza/thomas-tucker-MNtag_eXMKw-unsplash.jpg": "f33d",
	"./food/salad/Fattoush Salad with Cashew Nuts.png": "5d15",
	"./food/salad/Fattoush Salad with Cucumber and Tomato.png": "f43b",
	"./food/salad/Fattoush Salad.png": "8028",
	"./food/salad/Lamb Kebab With Salad.png": "5739",
	"./food/sauces/Yoghurt Cucumber Sauce.png": "5abb",
	"./footer/appStore.jpeg": "eb0a",
	"./footer/googe play.jpeg": "2404",
	"./footer/rm208-280-jj-059_1.jpg": "aff3",
	"./kaleb-tapp-J59wWPn09BE-unsplash.jpg": "fb57",
	"./languages/ar.jpg": "fcfc",
	"./languages/en.jpg": "fe31",
	"./languages/fr.png": "ecfc",
	"./logo-bg.png": "7fe7",
	"./logo-bg1.png": "97fb",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./myImage.jpg": "ac8c",
	"./our-customerse/background reserve now.jpg": "c90d",
	"./our-customerse/man1.png": "5971",
	"./our-customerse/man2.png": "4320",
	"./our-customerse/man3.png": "0e8a",
	"./pexels-chan-walrus-1059943.jpg": "0537",
	"./pexels-pixabay-315755.jpg": "2716",
	"./pexels-samfotograffo-3052362.jpg": "147d",
	"./spencer-davis-QdU9lnBB5RQ-unsplash.jpg": "8dbe",
	"./spencer-davis-xyilWXHQMLo-unsplash.jpg": "5ee5",
	"./user.png": "c121"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";